'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var StringsFromArray = React__default.forwardRef(function (props, ref) {
    var strings = props.strings, _a = props.nowrap, nowrap = _a === void 0 ? true : _a, _b = props.addPadding, addPadding = _b === void 0 ? false : _b;
    var cleanedStrings = strings.join(', ');
    return (React__default.createElement(styledComponents.Container, { "data-testid": 'strings-from-array', ref: ref, nowrap: nowrap, addPadding: addPadding }, cleanedStrings));
});

module.exports = StringsFromArray;
